import { apiClient } from './client';
import type { TaskTemplate } from '../types';

export interface TaskTemplateInput {
  name: string;
  description?: string | null;
  ticketType?: string | null;
  productLineId?: string | null;
  autoApply?: boolean;
  isActive?: boolean;
  sortOrder?: number;
  items?: Array<{ id?: string; title: string; description?: string | null; defaultAssigneeId?: string | null }>;
}

export const taskTemplatesApi = {
  list: async () => {
    const res = await apiClient.get('/task-templates');
    return res.data.data.templates as TaskTemplate[];
  },

  /** The template a ticket of this type / product line gets automatically, if any. */
  match: async (type?: string | null, productLineId?: string | null) => {
    const res = await apiClient.get('/task-templates/match', {
      params: { ...(type ? { type } : {}), ...(productLineId ? { productLineId } : {}) },
    });
    return res.data.data.template as TaskTemplate | null;
  },

  create: async (data: TaskTemplateInput) => {
    const res = await apiClient.post('/task-templates', data);
    return res.data.data.template as TaskTemplate;
  },

  update: async (id: string, data: Partial<TaskTemplateInput>) => {
    const res = await apiClient.put(`/task-templates/${id}`, data);
    return res.data.data.template as TaskTemplate;
  },

  remove: async (id: string) => {
    await apiClient.delete(`/task-templates/${id}`);
  },
};
